import coreFa from './fa.json'

const messages = {
  fa: {
    ...coreFa,
  },
}

export default messages
